import { render } from "./TemplateAutocomplete.vue?vue&type=template&id=af916c20&scoped=true"
import script from "./TemplateAutocomplete.vue?vue&type=script&lang=js"
export * from "./TemplateAutocomplete.vue?vue&type=script&lang=js"

import "./TemplateAutocomplete.vue?vue&type=style&index=0&id=af916c20&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af916c20"]])

export default __exports__